<template>
	<div>
		<v-toolbar
			dense
			flat
			dark
			:clipped-left="$vuetify.breakpoint.mdAndUp"
			fixed
			app
			color="primary"
		>
		<v-toolbar-side-icon
			v-if="! barraDeBusqueda && (
				this.$route.name === 'panel' ||
				this.$route.name === 'perfil' ||
				this.$route.name === 'lotes-titulos' ||
				this.$route.name === 'lotes-certificados' ||
				this.$route.name === 'certificados' ||
				this.$route.name === 'programa' ||
				this.$route.name === 'campus' ||
				this.$route.name === 'carrera' ||
				this.$route.name === 'responsables' ||
				this.$route.name === 'usuario' ||
				this.$route.name === 'configuracion'
				
			)"
			@click.stop="navToggle"
		>
		</v-toolbar-side-icon>
		
		<v-btn
			v-if="barraDeBusqueda && (
				this.$route.name === 'panel' ||
				this.$route.name === 'perfil' ||
				this.$route.name === 'lotes-titulos' ||
				this.$route.name === 'lotes-certificados' ||
				this.$route.name === 'certificados' ||
				this.$route.name === 'programa' ||
				this.$route.name === 'campus' ||
				this.$route.name === 'carrera' ||
				this.$route.name === 'responsables' ||
				this.$route.name === 'usuario' ||
				this.$route.name === 'configuracion'
			)"
			icon
			@click="barraDeBusqueda = false"
		>
			<v-icon>arrow_back</v-icon>
		</v-btn>

		<v-btn v-if="
				this.$route.name === 'perfil-editar' ||
				this.$route.name === 'lotes-titulos-subir' ||
				this.$route.name === 'lotes-titulos-mostrar' ||
				this.$route.name === 'lotes-titulos-editar' ||
				this.$route.name === 'lotes-titulos-titulos' ||
				this.$route.name === 'lotes-titulos-titulos-mostrar' ||
				this.$route.name === 'lotes-titulos-titulos-editar' ||
				this.$route.name === 'lotes-certificados-mostrar' ||
				this.$route.name === 'lotes-certificados-editar' ||
				this.$route.name === 'lotes-certificados-certificados' ||
				this.$route.name === 'lotes-certificados-certificados-capturar' ||
				this.$route.name === 'lotes-certificados-certificados-mostrar' ||
				this.$route.name === 'lotes-certificados-certificados-editar' ||
				this.$route.name === 'lotes-certificados-certificados-calificaciones' ||
				this.$route.name === 'lotes-certificados-certificados-calificaciones-capturar' ||
				this.$route.name === 'lotes-certificados-certificados-calificaciones-mostrar' ||
				this.$route.name === 'lotes-certificados-certificados-calificaciones-editar' ||
				this.$route.name === 'programa-subir' ||
				this.$route.name === 'programa-mostrar' ||
				this.$route.name === 'programa-editar' ||
				this.$route.name === 'programa-asignatura' ||
				this.$route.name === 'programa-asignatura-agregar' ||
				this.$route.name === 'programa-asignatura-mostrar' ||
				this.$route.name === 'programa-asignatura-editar' ||
				this.$route.name === 'campus-agregar' ||
				this.$route.name === 'campus-mostrar' ||
				this.$route.name === 'campus-editar' ||
				this.$route.name === 'carrera-agregar' ||
				this.$route.name === 'carrera-mostrar' ||
				this.$route.name === 'carrera-editar' ||
				this.$route.name === 'carrera-duplicar' ||
				this.$route.name === 'responsables-agregar' ||
				this.$route.name === 'responsables-mostrar' ||
				this.$route.name === 'responsables-firma' ||
				this.$route.name === 'responsables-editar' ||
				this.$route.name === 'usuario-agregar' ||
				this.$route.name === 'usuario-solicitud' ||
				this.$route.name === 'usuario-solicitud-registrar' ||
				this.$route.name === 'usuario-mostrar' ||
				this.$route.name === 'usuario-editar' ||
				this.$route.name === 'configuracion-editar'
			"
			icon
			@click="$router.go(-1)"
		>
			<v-icon>arrow_back</v-icon>
		</v-btn>

		<router-link
			class="navbar-brand"
			:to="{ name: this.$route.name }"
		>
    		<v-toolbar-title class="white--text">
				<div v-if="this.$route.name === 'perfil'"
				>
					Perfil
				</div>
				<div v-if="this.$route.name === 'perfil-editar'"
				>
					Editar Perfil
				</div>
				<div v-if="! barraDeBusqueda && (
						this.$route.name === 'lotes-titulos'
					)"
				>
					Lotes de Títulos
				</div>
				<div v-if="this.$route.name === 'lotes-titulos-subir'"
				>
					Subir Lote de Títulos
				</div>
				<div v-if="this.$route.name === 'lotes-titulos-mostrar'"
				>
					Lote de Títulos
				</div>
				<div v-if="this.$route.name === 'lotes-titulos-editar'"
				>
					Editar Lote de Títulos
				</div>
				<div v-if="! barraDeBusqueda && (
						this.$route.name === 'lotes-titulos-titulos'
					)"
				>
					Lote de Títulos
				</div>
				<div v-if="! barraDeBusqueda && (
						this.$route.name === 'lotes-titulos-titulos-mostrar'
					)"
				>
					Título
				</div>
				<div v-if="! barraDeBusqueda && (
						this.$route.name === 'lotes-titulos-titulos-editar'
					)"
				>
					Editar Título
				</div>
				<div v-if="! barraDeBusqueda && (
						this.$route.name === 'lotes-certificados'
					)"
				>
					Lotes de Certificados
				</div>
				<div v-if="! barraDeBusqueda && (
						this.$route.name === 'lotes-certificados-mostrar'
					)"
				>
					Lote de Certificados
				</div>
				<div v-if="! barraDeBusqueda && (
						this.$route.name === 'lotes-certificados-editar'
					)"
				>
					Editar Lote de Certificados
				</div>
				<div v-if="! barraDeBusqueda && (
						this.$route.name === 'lotes-certificados-certificados'
					)"
				>
					Certificados
				</div>
				<div v-if="! barraDeBusqueda && (
						this.$route.name === 'lotes-certificados-certificados-capturar'
					)"
				>
					Capturar Certificados
				</div>
				<div v-if="! barraDeBusqueda && (
						this.$route.name === 'lotes-certificados-certificados-mostrar'
					)"
				>
					Certificado
				</div>
				<div v-if="! barraDeBusqueda && (
						this.$route.name === 'lotes-certificados-certificados-editar'
					)"
				>
					Editar Certificado
				</div>
				<div v-if="! barraDeBusqueda && (
						this.$route.name === 'lotes-certificados-certificados-calificaciones'
					)"
				>
					Calificaciones
				</div>
				<div v-if="! barraDeBusqueda && (
						this.$route.name === 'lotes-certificados-certificados-calificaciones-capturar'
					)"
				>
					Capturar Calificaciones
				</div>
				<div v-if="! barraDeBusqueda && (
						this.$route.name === 'lotes-certificados-certificados-calificaciones-mostrar'
					)"
				>
					Calificación
				</div>
				<div v-if="! barraDeBusqueda && (
						this.$route.name === 'lotes-certificados-certificados-calificaciones-editar'
					)"
				>
					Editar Calificación
				</div>
				<div v-if="! barraDeBusqueda && this.$route.name === 'certificados'"
				>
					Certificados
				</div>
				<div v-if="! barraDeBusqueda && this.$route.name === 'programa'"
				>
					Programas de Estudio
				</div>
				<div v-if="this.$route.name === 'programa-mostrar'"
				>
					Programa de Estudio
				</div>
				<div v-if="this.$route.name === 'programa-editar'"
				>
					Editar Programa de Estudio
				</div>
				<div v-if="this.$route.name === 'programa-subir'"
				>
					Subir Programas de Estudio
				</div>
				<div v-if="this.$route.name === 'programa-asignatura'"
				>
					Asignaturas
				</div>
				<div v-if="this.$route.name === 'programa-asignatura-agregar'"
				>
					Agregar Asignatura
				</div>
				<div v-if="this.$route.name === 'programa-asignatura-mostrar'"
				>
					Asignatura
				</div>
				<div v-if="this.$route.name === 'programa-asignatura-editar'"
				>
					Editar Asignatura
				</div>
				<div v-if="! barraDeBusqueda && this.$route.name === 'campus'"
				>
					Planteles
				</div>
				<div v-if="this.$route.name === 'campus-agregar'"
				>
					Agregar Plantel
				</div>
				<div v-if="this.$route.name === 'campus-mostrar'"
				>
					Plantel
				</div>
				<div v-if="this.$route.name === 'campus-editar'"
				>
					Editar Plantel
				</div>
				<div v-if="! barraDeBusqueda && this.$route.name === 'carrera'"
				>
					Carreras
				</div>
				<div v-if="this.$route.name === 'carrera-agregar'"
				>
					Agregar Carrera
				</div>
				<div v-if="this.$route.name === 'carrera-mostrar'"
				>
					Carrera
				</div>
				<div v-if="this.$route.name === 'carrera-editar'"
				>
					Editar Carrera
				</div>
				<div v-if="this.$route.name === 'carrera-duplicar'"
				>
					Duplicar Carrera
				</div>
				<div v-if="! barraDeBusqueda && this.$route.name === 'responsables'"
				>
					Responsables
				</div>
				<div v-if="this.$route.name === 'responsables-agregar'"
				>
					Agregar Responsable
				</div>
				<div v-if="this.$route.name === 'responsables-mostrar'"
				>
					Responsable
				</div>
				<div v-if="this.$route.name === 'responsables-editar'"
				>
					Editar Responsable
				</div>
				<div v-if="this.$route.name === 'responsables-firma'"
				>
					Firma de Responsable
				</div>
				<div v-if="! barraDeBusqueda && this.$route.name === 'usuario'"
				>
					Usuarios
				</div>
				<div v-if="this.$route.name === 'usuario-solicitud'"
				>
					Solicitudes de usuarios
				</div>
				<div v-if="this.$route.name === 'usuario-solicitud-registrar'"
				>
					Registrar Usuario
				</div>
				<div v-if="this.$route.name === 'usuario-agregar'"
				>
					Agregar Usuario
				</div>
				<div v-if="this.$route.name === 'usuario-mostrar'"
				>
					Usuario
				</div>
				<div v-if="this.$route.name === 'usuario-editar'"
				>
					Editar Usuario
				</div>
				<div v-if="! barraDeBusqueda && (
						this.$route.name === 'panel'
					)"
				>
					Panel
				</div>
				<div v-if="! barraDeBusqueda && (
						this.$route.name === 'configuracion'
					)"
				>
					Configuración
				</div>
				<div v-if="! barraDeBusqueda && (
						this.$route.name === 'configuracion-editar'
					)"
				>
					Editar Configuración
				</div>
			</v-toolbar-title>
    </router-link>

	 <v-layout row justify-center wrap>

    <v-flex lg8 sm11 xs12>

			<v-text-field
				v-if="(!$vuetify.breakpoint.xsOnly || barraDeBusqueda) && (
					this.$route.name === 'lotes-titulos' ||
					this.$route.name === 'lotes-certificados' ||
					this.$route.name === 'programa' ||
					this.$route.name === 'campus' ||
					this.$route.name === 'carrera' ||
					this.$route.name === 'responsables' ||
					this.$route.name === 'usuario'
				)"
				@keyup.enter="guardarBusqueda() & $event.target.blur()"
				@click:clear="clearBusqueda"
				v-model="modelBusqueda"
				label="Buscar..."
				:background-color="barraDeBusqueda ? 'primary' : 'primary darken-1'"
				color="white"
				type="search"
				autocomplete="off"
				autocorrect="off"
				spellcheck="false"
				autofocus
				hide-details
				single-line
				clearable
				flat
				solo
			>

				<v-btn
					v-if="!$vuetify.breakpoint.xsOnly"
					slot="prepend-inner"
					icon
					@click="guardarBusqueda()"
				>
					<v-icon>search</v-icon>
				</v-btn>

				<v-btn
					v-if="!$vuetify.breakpoint.xsOnly && this.$route.name === 'programa'"
					slot="append"
					icon
					@click="openFilterDialog()"
				>
					<v-icon>filter_list</v-icon>
				</v-btn>

			</v-text-field>

    </v-flex>

		</v-layout>

		<v-tooltip bottom
			v-if="($vuetify.breakpoint.xsOnly && !barraDeBusqueda) && (
				this.$route.name === 'lotes-titulos' ||
				this.$route.name === 'lotes-certificados' ||
				this.$route.name === 'programa' ||
				this.$route.name === 'campus' ||
				this.$route.name === 'carrera' ||
				this.$route.name === 'responsables' ||
				this.$route.name === 'usuario'
			)"
		>
			<v-btn slot="activator" icon @click="barraDeBusqueda = true">
				<v-icon>search</v-icon>
			</v-btn>
			<span>Buscar</span>
		</v-tooltip>

		<v-btn
			v-if="$vuetify.breakpoint.xsOnly && barraDeBusqueda && this.$route.name === 'programa'"
			icon
			@click="openFilterDialog()"
		>
			<v-icon>filter_list</v-icon>
		</v-btn>

		<v-tooltip bottom v-if="!$vuetify.breakpoint.xsOnly && this.$route.name === 'lotes-titulos' && auth.role === 'Administrador'">
			<v-btn slot="activator" icon @click="descargarLayoutRVOESFederales">
				<v-icon>cloud_download</v-icon>
			</v-btn>
			<span>Descargar layout de RVOES federales</span>
		</v-tooltip>

		<v-tooltip bottom v-if="!$vuetify.breakpoint.xsOnly && this.$route.name === 'lotes-titulos'">
			<v-btn slot="activator" icon @click="descargarFormatoTitulo">
				<v-icon>archive</v-icon>
			</v-btn>
			<span>Descargar formato</span>
		</v-tooltip>

		<v-tooltip bottom v-if="!$vuetify.breakpoint.xsOnly && this.$route.name === 'lotes-titulos'">
			<v-btn slot="activator" icon :to="{ name: 'lotes-titulos-subir' }">
				<v-icon>file_upload</v-icon>
			</v-btn>
			<span>Subir lote de títulos</span>
		</v-tooltip>

		<v-menu
			v-if="$vuetify.breakpoint.xsOnly && !barraDeBusqueda && this.$route.name === 'lotes-titulos'"
			bottom
			left
		>

			<v-btn
				slot="activator"
				icon
			>
				<v-icon>more_vert</v-icon>
			</v-btn>

		
			<v-list>
				<v-list-tile
					v-if="auth.role === 'Administrador'"
					@click="descargarLayoutRVOESFederales"
				>
					<v-list-tile-title>Descargar layout de RVOES federales</v-list-tile-title>
				</v-list-tile>

				<v-list-tile
					@click="descargarFormatoTitulo"
				>
					<v-list-tile-title>Descargar formato de títulos</v-list-tile-title>
				</v-list-tile>

				<v-list-tile
					:to="{ name: 'lotes-titulos-subir' }"
				>
					<v-list-tile-title>Subir lote de títulos</v-list-tile-title>
				</v-list-tile>
			</v-list>
		</v-menu>

		<v-tooltip bottom v-if="this.$route.name === 'lotes-titulos-titulos' && estadoLote === 'capturado' && auth.role === 'Administrador'">
			<v-btn slot="activator" icon @click="firmarLoteTitulos($route.params.id)">
				<v-icon>gavel</v-icon>
			</v-btn>
			<span>Firmar lote de títulos</span>
		</v-tooltip>

		<v-tooltip bottom v-if="this.$route.name === 'lotes-titulos-titulos' && estadoLote === 'firmado' && tipoRvoeLote === 'Federal'">
			<v-btn slot="activator" icon @click="enviarALaSEP($route.params.id)">
				<v-icon>send</v-icon>
			</v-btn>
			<span>Enviar a la SEP</span>
		</v-tooltip>

		<v-menu
			v-if="this.$route.name === 'lotes-titulos-titulos' && (estadoLote === 'enviado' || (estadoLote === 'firmado' && tipoRvoeLote === 'Estatal'))"
			bottom
			left
			open-on-hover
		>

			<v-btn
				slot="activator"
				icon
			>
				<v-icon>get_app</v-icon>
			</v-btn>

			<v-list>
				<v-list-tile
					@click="descargarXMLTitulos($route.params.id)"
				>
					<v-list-tile-title>Descargar XML</v-list-tile-title>
				</v-list-tile>
				<v-list-tile
					@click="descargarCadenasTitulos($route.params.id)"
				>
					<v-list-tile-title>Descargar Cadenas Originales</v-list-tile-title>
				</v-list-tile>
			</v-list>
		</v-menu>

		<v-tooltip bottom v-if="this.$route.name === 'lotes-titulos-titulos' && estadoLote === 'enviado'">
			<v-btn slot="activator" icon @click="descargarFoliosTitulos($route.params.id)">
				<v-icon>list</v-icon>
			</v-btn>
			<span>Descargar folios de títulos</span>
		</v-tooltip>

		<v-tooltip bottom v-if="this.$route.name === 'lotes-titulos-titulos' && estadoLote === 'enviado'">
			<v-btn slot="activator" icon @click="enviarAAutenticar($route.params.id)">
				<v-icon>done</v-icon>
			</v-btn>
			<span>Enviar a autenticar</span>
		</v-tooltip>

		<v-tooltip bottom v-if="this.$route.name === 'lotes-titulos-titulos-mostrar'">
			<v-btn slot="activator" icon @click="descargarPDFTitulo($route.params.id, $route.params.id2)">
				<v-icon>description</v-icon>
			</v-btn>
			<span>Descargar Título en PDF</span>
		</v-tooltip>

		<v-tooltip bottom v-if="this.$route.name === 'lotes-certificados'">
			<v-btn slot="activator" icon @click="capturarCertificados">
				<v-icon>add</v-icon>
			</v-btn>
			<span>Capturar certificados</span>
		</v-tooltip>

		<v-tooltip bottom v-if="this.$route.name === 'lotes-certificados-certificados'">
			<v-btn slot="activator" icon @click="descargarLoteCertificados($route.params.id)">
				<v-icon>list</v-icon>
			</v-btn>
			<span>Descargar lote de certificados</span>
		</v-tooltip>

		<v-tooltip bottom v-if="this.$route.name === 'lotes-certificados-certificados' && (auth.role === 'Administrador' || (auth.role === 'Escolares' && estadoLote === 'capturado')) && tipoRvoeLote === 'Federal'">
			<v-btn slot="activator" icon @click="descargarFormatoPagosCertificados($route.params.id)">
				<v-icon>archive</v-icon>
			</v-btn>
			<span>Descargar formato de pagos de certificados</span>
		</v-tooltip>

		<v-tooltip bottom v-if="this.$route.name === 'lotes-certificados-certificados' && estadoLote === 'capturado' && auth.role === 'Administrador'">
			<v-btn slot="activator" icon @click="autorizarLoteCertificados($route.params.id)">
				<v-icon>thumb_up</v-icon>
			</v-btn>
			<span>Autorizar lote de certificados</span>
		</v-tooltip>

		<v-tooltip bottom v-if="this.$route.name === 'lotes-certificados-certificados' && estadoLote === 'autorizado' && auth.role === 'Administrador'">
			<v-btn slot="activator" icon @click="firmarLoteCertificados($route.params.id)">
				<v-icon>gavel</v-icon>
			</v-btn>
			<span>Firmar lote de certificados</span>
		</v-tooltip>

		<v-tooltip bottom v-if="this.$route.name === 'lotes-certificados-certificados' && estadoLote === 'firmado' && tipoRvoeLote === 'Federal'">
			<v-btn slot="activator" icon @click="mostrarFolioPago">
				<v-icon>receipt</v-icon>
			</v-btn>
			<span>Ver folio de pago</span>
		</v-tooltip>

		<v-tooltip bottom v-if="this.$route.name === 'lotes-certificados-certificados' && estadoLote === 'firmado'">
			<v-btn slot="activator" icon @click="descargarXMLCertificados($route.params.id)">
				<v-icon>get_app</v-icon>
			</v-btn>
			<span>Descargar XML de certificados</span>
		</v-tooltip>

		<v-tooltip bottom v-if="this.$route.name === 'lotes-certificados-certificados-capturar'">
			<v-btn slot="activator" icon @click="enviarCertificados">
				<v-icon>save</v-icon>
			</v-btn>
		</v-tooltip>

		<v-tooltip bottom v-if="this.$route.name === 'lotes-certificados-certificados-mostrar'">
			<v-btn slot="activator" icon :to="{ name: 'lotes-certificados-certificados-calificaciones', params: { id: this.$route.params.id, id2: this.$route.params.id2 } }">
				<v-icon>assignment_turned_in</v-icon>
			</v-btn>
			<span>Calificaciones</span>
		</v-tooltip>

		<v-tooltip bottom v-if="!$vuetify.breakpoint.xsOnly && this.$route.name === 'programa' && auth.role === 'Administrador'">
			<v-btn slot="activator" icon @click="descargarXLSXProgramasDeEstudio">
				<v-icon>file_download</v-icon>
			</v-btn>
			<span>Descargar programas de estudio</span>
		</v-tooltip>

		<v-tooltip bottom v-if="!$vuetify.breakpoint.xsOnly && this.$route.name === 'programa' && auth.role === 'Administrador'">
			<v-btn slot="activator" icon @click="refactorizarAsignaturas">
				<v-icon>assignment_turned_in</v-icon>
			</v-btn>
			<span>Refactorizar asignaturas</span>
		</v-tooltip>

		<v-tooltip bottom v-if="!$vuetify.breakpoint.xsOnly && this.$route.name === 'programa' && auth.role === 'Administrador'">
			<v-btn slot="activator" icon @click="descargarLayoutProgramasDeEstudio">
				<v-icon>cloud_download</v-icon>
			</v-btn>
			<span>Descargar layout de programas de estudio</span>
		</v-tooltip>

		<v-tooltip bottom v-if="!$vuetify.breakpoint.xsOnly && this.$route.name === 'programa'">
			<v-btn slot="activator" icon @click="descargarFormatoPrograma">
				<v-icon>archive</v-icon>
			</v-btn>
			<span>Descargar formato</span>
		</v-tooltip>

		<v-tooltip bottom v-if="!$vuetify.breakpoint.xsOnly && this.$route.name === 'programa'">
			<v-btn slot="activator" icon :to="{ name: 'programa-subir' }">
				<v-icon>file_upload</v-icon>
			</v-btn>
			<span>Subir programas de estudio</span>
		</v-tooltip>

		<v-menu
			v-if="$vuetify.breakpoint.xsOnly && !barraDeBusqueda && this.$route.name === 'programa'"
			bottom
			left
		>

			<v-btn
				slot="activator"
				icon
			>
				<v-icon>more_vert</v-icon>
			</v-btn>

		
			<v-list>
				<v-list-tile
					v-if="auth.role === 'Administrador'"
					@click="descargarXLSXProgramasDeEstudio"
				>
					<v-list-tile-title>Descargar programas de estudio</v-list-tile-title>
				</v-list-tile>

				<v-list-tile
					v-if="auth.role === 'Administrador'"
					@click="refactorizarAsignaturas"
				>
					<v-list-tile-title>Refactorizar asignaturas</v-list-tile-title>
				</v-list-tile>

				<v-list-tile
					v-if="auth.role === 'Administrador'"
					@click="descargarLayoutProgramasDeEstudio"
				>
					<v-list-tile-title>Descargar layout de programas de estudio</v-list-tile-title>
				</v-list-tile>

				<v-list-tile
					@click="descargarFormatoPrograma"
				>
					<v-list-tile-title>Descargar formato de programas de estudio</v-list-tile-title>
				</v-list-tile>

				<v-list-tile
					:to="{ name: 'programa-subir' }"
				>
					<v-list-tile-title>Subir programas de estudio</v-list-tile-title>
				</v-list-tile>
			</v-list>
		</v-menu>

		<v-tooltip bottom v-if="this.$route.name === 'programa-mostrar'">
			<v-btn slot="activator" icon :to="{ name: 'programa-asignatura' }">
				<v-icon>assignment</v-icon>
			</v-btn>
			<span>Asignaturas</span>
		</v-tooltip>

		<v-tooltip bottom v-if="this.$route.name === 'programa-asignatura'">
			<v-btn slot="activator" icon :to="{ name: 'programa-asignatura-agregar' }">
				<v-icon>add</v-icon>
			</v-btn>
			<span>Agregar asignatura</span>
		</v-tooltip>

		<v-tooltip bottom v-if="!barraDeBusqueda && this.$route.name === 'responsables'">
			<v-btn slot="activator" icon :to="{ name: 'responsables-agregar' }">
				<v-icon>add</v-icon>
			</v-btn>
			<span>Agregar responsable</span>
		</v-tooltip>

		<v-tooltip bottom v-if="this.$route.name === 'responsables-mostrar'">
			<v-btn slot="activator" icon @click="subirFirma($route.params.id)">
				<v-icon>vpn_key</v-icon>
			</v-btn>
			<span>Subir firma</span>
		</v-tooltip>

		<v-tooltip bottom v-if="!barraDeBusqueda && this.$route.name === 'campus'">
			<v-btn slot="activator" icon :to="{ name: 'campus-agregar' }">
				<v-icon>add</v-icon>
			</v-btn>
			<span>Agregar plantel</span>
		</v-tooltip>

		<v-tooltip bottom v-if="!barraDeBusqueda && this.$route.name === 'carrera'">
			<v-btn slot="activator" icon :to="{ name: 'carrera-agregar' }">
				<v-icon>add</v-icon>
			</v-btn>
			<span>Agregar carrera</span>
		</v-tooltip>

		<v-tooltip bottom v-if="!barraDeBusqueda && this.$route.name === 'usuario'">
			<v-btn slot="activator" icon :to="{ name: 'usuario-solicitud' }">
				<v-icon>notifications</v-icon>
			</v-btn>
			<span>Ver solicitudes de registro</span>
		</v-tooltip>

		<v-tooltip bottom v-if="!barraDeBusqueda && this.$route.name === 'usuario'">
			<v-btn slot="activator" icon :to="{ name: 'usuario-agregar' }">
				<v-icon>add</v-icon>
			</v-btn>
			<span>Agregar usuario</span>
		</v-tooltip>
		
	</v-toolbar>

	<v-dialog v-model="loadingDialog" persistent width="300">
		<v-card color="primary" dark>
			<v-card-text>Espera un momento
				<v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
			</v-card-text>
		</v-card>
	</v-dialog>

	<v-dialog
		v-model="firmarTitulosDialog"
		persistent
		max-width="400px"
	>
		<v-card>
			<v-card-title>
				<span class="headline">Firmar lote de títulos</span>
			</v-card-title>
			<v-card-text>
				<v-form>
					<v-container>
						<v-text-field
							v-for="(firmante, index) in firmantes"
							:key="index"
							:value="firmante.nombre + ' ' + firmante.primer_apellido + ' ' + firmante.segundo_apellido"
							outline
							readonly
							single-line
						></v-text-field>
					</v-container>
				</v-form>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="primary darken-1" flat @click="firmarTitulosDialog = false">Cancelar</v-btn>
				<v-btn color="primary darken-1" @click="firmar" :disabled="loading">Firmar</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>

	<v-dialog
		v-model="firmarCertificadosDialog"
		persistent
		max-width="400px"
	>
		<v-card>
			<v-card-title>
				<span class="headline">Firmar lote de certificados</span>
			</v-card-title>
			<v-card-text>
				<v-form>
					<v-container>
						<v-text-field
						  :label="labels.folio_pago"
							v-model="folioPago"
							:error-messages="errors.folio_pago"
              				:rules="[rules.required('folio_pago')]"
							autofocus
						></v-text-field>
					</v-container>
				</v-form>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="primary darken-1" flat @click="firmarCertificadosDialog = false">Cancelar</v-btn>
				<v-btn color="primary darken-1" @click="firmar">Firmar</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>

	<v-dialog
		v-model="firmarCertificadosEstatalDialog"
		persistent
		max-width="400px"
	>
		<v-card>
			<v-card-title>
				<span class="headline">Firmar lote de certificados</span>
			</v-card-title>
			<v-card-text>
				<v-form>
					<v-container>
						<v-text-field
							v-for="(firmante, index) in firmantes"
							:key="index"
							:value="firmante.nombre + ' ' + firmante.primer_apellido + ' ' + firmante.segundo_apellido"
							outline
							readonly
							single-line
						></v-text-field>
					</v-container>
				</v-form>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="primary darken-1" flat @click="firmarCertificadosEstatalDialog = false">Cancelar</v-btn>
				<v-btn color="primary darken-1" @click="firmar">Firmar</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>

	<v-dialog
		v-model="folioSolicitudAutenticacionDialog"
		persistent
		max-width="400px"
	>
		<v-card>
			<v-card-title>
				<span class="headline">Enviar lote a autenticar</span>
			</v-card-title>
			<v-card-text>
				<v-form>
					<v-container>
						<v-text-field
						  :label="labels.folio_solicitud"
							v-model="folioPago"
							:error-messages="errors.folio_solicitud"
              				:rules="[rules.required('folio_solicitud')]"
							autofocus
						></v-text-field>
					</v-container>
				</v-form>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="primary darken-1" flat @click="folioSolicitudAutenticacionDialog = false">Cancelar</v-btn>
				<v-btn color="primary darken-1" @click="enviarFolios">Continuar</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>

	<v-dialog
		v-model="folioDialog"
		max-width="400px"
	>
		<v-card>
			<v-card-title>
				<span class="headline">Folio de Pago</span>
			</v-card-title>
			<v-card-text>
				<v-form>
					<v-container>
						<v-layout align-center justify-center row>
							<div ref="folio" class="title font-weight-medium">
								{{ folioPago }}
							</div>
							<v-btn icon @click="copiarFolio">
								<v-icon>content_copy</v-icon>
							</v-btn>
						</v-layout>
					</v-container>
				</v-form>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="primary darken-1" flat @click="folioDialog = false">Cerrar</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>

	<v-dialog
		v-model="filterDialog"
		persistent
		max-width="500px"
		:fullscreen="$vuetify.breakpoint.xsOnly"
	>
	
		<v-toolbar 
			v-if="$vuetify.breakpoint.xsOnly"
			dark
			fixed
			dense
			color="primary"
		>
			<v-btn icon>
				<v-icon
					@click="filterDialog = false"
				>
					arrow_back
				</v-icon>
			</v-btn>

			<router-link
				class="navbar-brand"
				:to="{ name: this.$route.name }"
			>
				<v-toolbar-title class="white--text">
					Filtro de búsqueda
				</v-toolbar-title>
			</router-link>

			<v-spacer></v-spacer>

			<v-toolbar-items>
				<v-btn flat @click="aplicarFiltro">Aplicar</v-btn>
			</v-toolbar-items>
		</v-toolbar>

		<v-card>
			<v-card-title>
				<span class="headline">Filtro de búsqueda</span>
			</v-card-title>
			<v-card-text>

				<v-autocomplete
					v-if="this.$route.name === 'programa'"
					@keyup.enter="$event.target.blur()"
					:label="labels.campus"
					v-model="form.campus"
					:items="campuses"
					item-text="nombre"
					item-value="nombre"
					attach
					chips
					multiple
					deletable-chips
					dense
					hide-no-data
				></v-autocomplete>

				<v-autocomplete
					v-if="this.$route.name === 'programa'"
					@keyup.enter="$event.target.blur()"
					:label="labels.carrera"
					v-model="form.carrera"
					:items="carreras"
					item-text="nombre"
					item-value="nombre"
					attach
					chips
					multiple
					deletable-chips
					dense
					hide-no-data
				></v-autocomplete>

				<v-select
					v-if="this.$route.name === 'programa'"
					:label="labels.modalidad"
					v-model="form.modalidad"
					:items="modalidades"
					item-text="nombre"
					item-value="nombre"
					attach
					chips
					multiple
					deletable-chips
					dense
					hide-no-data
				></v-select>

				<v-select
					v-if="this.$route.name === 'programa'"
					:label="labels.tipo_periodo"
					v-model="form.tipo_periodo"
					:items="tipos_periodo"
					item-text="nombre"
					item-value="nombre"
					attach
					chips
					multiple
					deletable-chips
					dense
					hide-no-data
				></v-select>

				<v-select
					v-if="this.$route.name === 'programa'"
					:label="labels.tipo_rvoe"
					v-model="form.tipo_rvoe"
					:items="['ESTATAL', 'FEDERAL']"
					attach
					chips
					multiple
					deletable-chips
					dense
				></v-select>

				<v-text-field
					v-if="this.$route.name === 'programa'"
					:label="labels.numero_rvoe"
					v-model="form.numero_rvoe"
				></v-text-field>

				<v-text-field
					v-if="this.$route.name === 'programa'"
					:label="labels.fecha_rvoe"
					v-model="form.fecha_rvoe"
				></v-text-field>

				<v-text-field
					v-if="this.$route.name === 'programa'"
					:label="labels.clave_plan"
					v-model="form.clave_plan"
				></v-text-field>

				<v-text-field
					v-if="this.$route.name === 'programa'"
					:label="labels.calificacion_maxima"
					v-model="form.calificacion_maxima"
				></v-text-field>

				<v-text-field
					v-if="this.$route.name === 'programa'"
					:label="labels.calificacion_minima"
					v-model="form.calificacion_minima"
				></v-text-field>

				<v-text-field
					v-if="this.$route.name === 'programa'"
					:label="labels.calificacion_minima_aprobatoria"
					v-model="form.calificacion_minima_aprobatoria"
				></v-text-field>

			</v-card-text>
			<v-card-actions v-if="!$vuetify.breakpoint.xsOnly">
				<v-spacer></v-spacer>
				<v-btn color="primary darken-1" flat @click="filterDialog = false">Cancelar</v-btn>
				<v-btn color="primary darken-1" flat @click="aplicarFiltro">Aplicar</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>

	</div>
</template>

<script>
	import axios from "axios"
	import { mapGetters } from "vuex"
	import { api } from "~/config"
	import { settings } from '~/config'
	import Form from '~/mixins/form'

	export default {
		mixins: [Form],

		data: () => ({
			loadingDialog: false,
			filterDialog: false,
			firmarCertificadosDialog: false,
			firmarCertificadosEstatalDialog: false,
			folioSolicitudAutenticacionDialog: false,
			firmarTitulosDialog: false,
			folioDialog: false,

			loteTitulosSeleccionado: null,
			loteCertificadosSeleccionado: null,
			documentoAFirmar: null,

			modelBusqueda: null,

			barraDeBusqueda: false,

			form: {
				campus: null,
				carrera: null,
				modalidad: null,
				tipo_periodo: null,
				tipo_rvoe: null,
				clave_plan: null,
    		    numero_rvoe: null,
				fecha_rvoe: null,
				calificacion_maxima: null,
				calificacion_minima: null,
				calificacion_minima_aprobatoria: null,
			},
			
			campuses: [],
     		carreras: [],
			modalidades: [],
			tipos_periodo: [],
			firmantes: [],

			folioPago: null
		}),

		computed: mapGetters({
			auth: 'auth/user',
			busqueda: "auth/busqueda",
			estadoLote: "auth/estadoLote",
			tipoRvoeLote: "auth/tipoRvoeLote"
		}),

		watch: {
			busqueda(val) {
				this.modelBusqueda = val
			},

			estadoLote(val) {
				console.log(val)
    		},

			tipoRvoeLote(val) {
				console.log(val)
    		}
		},

		methods: {
			navToggle() {
				this.$emit('navToggle')
			},

			clearBusqueda() {
				this.modelBusqueda = null
				this.guardarBusqueda()
			},

			guardarBusqueda() {
				this.$store.dispatch('auth/guardarBusqueda', { busqueda: this.modelBusqueda })
			},

			enviarCertificados() {
				this.$store.dispatch('auth/guardarEnviarCertificados', { enviarCertificados: true })
			},

			subirFirma(id) {
				this.$router.push({ name: "responsables-firma", params: { id: id } })
			},

			mostrarFolioPago() {
				this.folioDialog = true
				this.getFolioPago()
			},

			getFolioPago() {
				axios
					.get(api.path('lotes_certificados.folio_pago', { id: this.$route.params.id } ))
					.then(res => {
							this.folioPago = res.data
					})
					.catch(err => {
						this.handleErrors(err.response.data.errors)
					})
					.then(() => {})
			},

			copiarFolio() {
				let me = this
				this.$copyText(this.folioPago, this.$refs.folio).then(function (e) {
					me.$toast.success("Folio de pago copiado al portapapeles.")
				}, function (e) {
					me.$toast.success("No se puede copiar el folio de pago al portapapeles.")
				})
			},

			autorizarLoteCertificados(id) {
				this.loteCertificadosSeleccionado = id
				
				this.$confirm('Esta acción autorizará el lote de certificados.', {
					buttonTrueText: 'Autorizar',
					color: 'primary',
					icon: '',
					title: '¿Autorizar Certificados?',
				}).then(
					res => {
						if (res) {
							this.loadingDialog = true
							axios
								.post(api.path('lotes_certificados.autorizar', { id: this.loteCertificadosSeleccionado }))
								.then(res => {
									this.$toast.success('Lote de certificados autorizados correctamente.')
									this.$router.go(-1)
								})
								.catch(err => {
									this.$toast.error('Vuelva a intentarlo mas tarde.')
									this.handleErrors(err.response.data.errors)
								})
								.then(() => {
									this.loadingDialog = false
								})
						}
					}
				)
			},

			descargarLoteCertificados(id) {
				this.loadingDialog = true
				axios
					.get(api.path("lotes_certificados.xlsx", { id: id }), { responseType: "blob" })
					.then(res => {
						if (res.data.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
							let blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
							let link = document.createElement('a')
							link.href = window.URL.createObjectURL(blob)
							link.download = 'certificados_' + id + '.xlsx'
							link.click()
						} else if (res.data.error) {
							this.$toast.error(res.data.error)
						} else {
							this.$toast.error('Vuelva a intentarlo mas tarde.')
						}
					})
					.catch(err => {
						this.loadingDialog = false
						this.$toast.error("Vuelva a intentarlo mas tarde.")
						this.handleErrors(err.response.data.errors)
					})
					.then(() => {
						this.loadingDialog = false
					})
			},

			firmarLoteTitulos(id) {
				this.firmarTitulosDialog = true
				this.documentoAFirmar = 'Títulos'
				this.loteTitulosSeleccionado = id
				this.getFirmantesTitulos()
			},

			firmarLoteCertificados(id) {
				this.folioPago = ''
				if (this.tipoRvoeLote === 'Estatal') {
					this .firmarCertificadosEstatalDialog = true
					this.getFirmantesCertificados()
				} else {
					this .firmarCertificadosDialog = true
				}
				this.documentoAFirmar = 'Certificados'
				this.loteTitulosSeleccionado = id
				this.loteCertificadosSeleccionado = id				
			},

			firmar() {
				if(this.documentoAFirmar === 'Certificados') {
					this.firmarCertificadosDialog = false
					this.firmarCertificadosEstatalDialog = false
					
					this.loadingDialog = true
					axios
						.post(api.path('lotes_certificados.firmar', { id: this.loteCertificadosSeleccionado }), {
							folio_pago: this.folioPago
						})
						.then(res => {
							this.$toast.success('Lote de certificados firmados correctamente.')
							this.$router.go(-1)
						})
						.catch(err => {
							this.$toast.error('Vuelva a intentarlo mas tarde.')
							this.handleErrors(err.response.data.errors)
						})
						.then(() => {
							this.loadingDialog = false
						})
				} else if(this.documentoAFirmar === 'Títulos') {
					this.firmarTitulosDialog = false
					this.loadingDialog = true
					axios
						.post(api.path('titulos.firmar', { id: this.loteTitulosSeleccionado }))
						.then(res => {
							this.$toast.success('Lote de títulos firmados correctamente.')
							this.$router.go(-1)
						})
						.catch(err => {
							this.$toast.error('Vuelva a intentarlo mas tarde.')
							this.handleErrors(err.response.data.errors)
						})
						.then(() => {
							this.loadingDialog = false
						})
				}
			},

			enviarFolios() {

			},

			enviarALaSEP(id) {
				this.loadingDialog = true
				axios
					.post(api.path("titulos.sep", { id: id }))
					.then(res => {
						this.$toast.success("Lote de títulos enviados correctamente.")
						this.$router.go(-1)
					})
					.catch(err => {
						this.$toast.error("Vuelva a intentarlo mas tarde.")
						this.handleErrors(err.response.data.errors)
					})
					.then(() => {
						this.loadingDialog = false
					})
			},

			descargarXMLTitulos(id) {
				this.loadingDialog = true
				axios
					.get(api.path("titulos.zip", { id: id }), { responseType: "blob" })
					.then(res => {
						if (res.data.type === "application/zip") {
							let blob = new Blob([res.data], { type: "application/zip" })
							let link = document.createElement("a")
							link.href = window.URL.createObjectURL(blob)
							link.download = "titulo_" + id + ".zip"
							link.click()
						} else {
							this.$toast.error("Vuelva a intentarlo mas tarde.")
						}
					})
					.catch(err => {
						this.loadingDialog = false
						this.$toast.error("Vuelva a intentarlo mas tarde.")
						this.handleErrors(err.response.data.errors)
					})
					.then(() => {
						this.loadingDialog = false
					})
			},

			descargarCadenasTitulos(id) {
				this.loadingDialog = true
				axios
					.get(api.path("titulos.cadenas", { id: id }), { responseType: "blob" })
					.then(res => {
						if (res.data.type === "application/zip") {
							let blob = new Blob([res.data], { type: "application/zip" })
							let link = document.createElement("a")
							link.href = window.URL.createObjectURL(blob)
							link.download = "titulo_" + id + "_cadenas.zip"
							link.click()
						} else {
							this.$toast.error("Vuelva a intentarlo mas tarde.")
						}
					})
					.catch(err => {
						this.loadingDialog = false
						this.$toast.error("Vuelva a intentarlo mas tarde.")
						this.handleErrors(err.response.data.errors)
					})
					.then(() => {
						this.loadingDialog = false
					})
			},

			descargarFoliosTitulos(id) {
				this.loadingDialog = true
				axios
					.get(api.path('titulos.folios', { id: id }), { responseType: 'blob' })
					.then(res => {
						if (res.data.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
							let blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
							let link = document.createElement('a')
							link.href = window.URL.createObjectURL(blob)
							link.download = 'formato_folios.xlsx'
							link.click()
						} else if (res.data.error) {
							this.$toast.error(res.data.error)
						} else {
							this.$toast.error('Vuelva a intentarlo mas tarde.')
						}
					})
					.catch(err => {
						this.loadingDialog = false
						this.$toast.error('Vuelva a intentarlo mas tarde.')
						this.handleErrors(err.response.data.errors)
					})
					.then(() => {
						this.loadingDialog = false
					})
			},

			enviarAAutenticar(id) {
				this.folioSolicitudAutenticacionDialog = true
			},

			descargarPDFTitulo(id, id2) {
				this.loadingDialog = true
				axios
					.get(api.path('titulos.titulos.pdf', { id: this.$route.params.id, id2: this.$route.params.id2 }), { responseType: 'blob' })
					.then(res => {
						if (res.data.type === 'application/pdf') {
							let blob = new Blob([res.data], { type: 'application/pdf' })
							let link = document.createElement('a')
							link.href = window.URL.createObjectURL(blob)

							const contentDisposition = res.headers['content-disposition'];
							let fileName = contentDisposition.split(';')[1].split('filename')[1].split('=')[1].trim().replace(/["']/g, "");

							link.download = fileName
							link.click()
						} else if (res.data.error) {
							this.$toast.error(res.data.error)
						} else {
							this.$toast.error('Vuelva a intentarlo mas tarde.')
						}
					})
					.catch(err => {
						this.loadingDialog = false
						this.$toast.error('Vuelva a intentarlo mas tarde.')
						this.handleErrors(err.response.data.errors)
					})
					.then(() => {
						this.loadingDialog = false
					})
			},

			descargarXMLCertificados(id) {
				this.loadingDialog = true
				axios
					.get(api.path("lotes_certificados.zip", { id: id }), { responseType: "blob" })
					.then(res => {
						if (res.data.type === "application/zip") {
							let blob = new Blob([res.data], { type: "application/zip" })
							let link = document.createElement("a")
							link.href = window.URL.createObjectURL(blob)
							link.download = "certificados_xml_" + id + ".zip"
							link.click()
						} else {
							this.$toast.error("Vuelva a intentarlo mas tarde.")
						}
					})
					.catch(err => {
						this.loadingDialog = false
						this.$toast.error("Vuelva a intentarlo mas tarde.")
						this.handleErrors(err.response.data.errors)
					})
					.then(() => {
						this.loadingDialog = false
					})
			},

			openFilterDialog() {
				this.filterDialog = true
				if(this.$route.name === 'programa') {
					this.getCampuses()
					this.getCarreras()
					this.getCatalogoModalidad()
					this.getCatalogoTipoPeriodo()
				}
			},

			aplicarFiltro() {
				this.filterDialog = false
				this.modelBusqueda = ''
				if(this.$route.name === 'programa') {
					if(this.form.campus && this.form.campus.length > 0) {
						this.modelBusqueda += " campuses:(" + this.form.campus.join(',') + ")"
					}
					if(this.form.carrera && this.form.carrera.length > 0) {
						this.modelBusqueda += " carreras:(" + this.form.carrera.join(',') + ")"
					}
					if(this.form.modalidad && this.form.modalidad.length > 0) {
						this.modelBusqueda += " modalidades:(" + this.form.modalidad.join(',') + ")"
					}
					if(this.form.tipo_periodo && this.form.tipo_periodo.length > 0) {
						this.modelBusqueda += " tipos_periodo:(" + this.form.tipo_periodo.join(',') + ")"
					}
					if(this.form.tipo_rvoe) {
						this.modelBusqueda += " tipos_rvoe:(" + this.form.tipo_rvoe + ")"
					}
					if(this.form.clave_plan) {
						this.modelBusqueda += " clave_plan:(" + this.form.clave_plan + ")"
					}
					if(this.form.numero_rvoe) {
						this.modelBusqueda += " numero_rvoe:(" + this.form.numero_rvoe + ")"
					}
					if(this.form.fecha_rvoe) {
						this.modelBusqueda += " fecha_rvoe:(" + this.form.fecha_rvoe + ")"
					}
					if(this.form.calificacion_maxima) {
						this.modelBusqueda += " calificacion_maxima:(" + this.form.calificacion_maxima + ")"
					}
					if(this.form.calificacion_minima) {
						this.modelBusqueda += " calificacion_minima:(" + this.form.calificacion_minima + ")"
					}
					if(this.form.calificacion_minima_aprobatoria) {
						this.modelBusqueda += " calificacion_minima_aprobatoria:(" + this.form.calificacion_minima_aprobatoria + ")"
					}
				}
				this.guardarBusqueda()
			},

			getFirmantesTitulos() {
				axios
					.get(api.path('titulos.firmantes', { id: this.$route.params.id } ))
					.then(res => {
							this.firmantes = res.data
					})
					.catch(err => {
						this.handleErrors(err.response.data.errors)
					})
					.then(() => {})
			},

			getFirmantesCertificados() {
				axios
					.get(api.path('lotes_certificados.firmantes', { id: this.$route.params.id } ))
					.then(res => {
							this.firmantes = res.data
					})
					.catch(err => {
						this.handleErrors(err.response.data.errors)
					})
					.then(() => {})
			},

			getCampuses() {
        axios
          .get(api.path('campus'))
          .then(res => {
            this.campuses = res.data.data
          })
          .catch(err => {
            this.handleErrors(err.response.data.errors)
          })
          .then(() => {})
      },

      getCarreras() {
        axios
        .get(api.path('carreras'))
        .then(res => {
            this.carreras = res.data.data
        })
        .catch(err => {
        	this.handleErrors(err.response.data.errors)
        })
        .then(() => {})
      },

      getCatalogoModalidad() {
        axios
        .get(api.path('catalogos.modalidad'))
        .then(res => {
            this.modalidades = res.data
        })
        .catch(err => {
        	this.handleErrors(err.response.data.errors)
        })
          .then(() => {})
		},
			
		getCatalogoTipoPeriodo() {
			axios
			.get(api.path('catalogos.tipo_periodo'))
			.then(res => {
				this.tipos_periodo = res.data
			})
			.catch(err => {
				this.handleErrors(err.response.data.errors)
			})
			.then(() => {})
		},
			
		descargarFormatoPagosCertificados() {
			this.loadingDialog = true
			axios
				.get(api.path('lotes_certificados.formato_pagos', { id: this.$route.params.id }), { responseType: 'blob' })
				.then(res => {
					if (res.data.type === 'application/zip') {
						let blob = new Blob([res.data], { type: 'application/zip' })
						let link = document.createElement('a')
						link.href = window.URL.createObjectURL(blob)
						link.download = 'formato_pagos_certificados.zip'
						link.click()
					} else if (res.data.error) {
						this.$toast.error(res.data.error)
					} else {
						this.$toast.error('Vuelva a intentarlo mas tarde.')
					}
				})
				.catch(err => {
					this.loadingDialog = false
					this.$toast.error('Vuelva a intentarlo mas tarde.')
					this.handleErrors(err.response.data.errors)
				})
				.then(() => {
					this.loadingDialog = false
				})
			},

			capturarCertificados() {
				this.$router.push({ name: "lotes-certificados-certificados-capturar" })
			},

			descargarFormatoTitulo() {
				this.loadingDialog = true
				axios
					.get(api.path('titulos.formato'), { responseType: 'blob' })
					.then(res => {
						if (res.data.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
							let blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
							let link = document.createElement('a')
							link.href = window.URL.createObjectURL(blob)
							link.download = 'formato_titulos.xlsx'
							link.click()
						} else if (res.data.error) {
							this.$toast.error(res.data.error)
						} else {
							this.$toast.error('Vuelva a intentarlo mas tarde.')
						}
					})
					.catch(err => {
						this.loadingDialog = false
						this.$toast.error('Vuelva a intentarlo mas tarde.')
						this.handleErrors(err.response.data.errors)
					})
					.then(() => {
						this.loadingDialog = false
					})
			},

			descargarFormatoPrograma() {
				this.loadingDialog = true
				axios
					.get(api.path('programas.formato'), { responseType: 'blob' })
					.then(res => {
						if (res.data.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
							let blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
							let link = document.createElement('a')
							link.href = window.URL.createObjectURL(blob)
							link.download = 'formato_programas_de_estudio.xlsx'
							link.click()
						} else if (res.data.error) {
							this.$toast.error(res.data.error)
						} else {
							this.$toast.error('Vuelva a intentarlo mas tarde.')
						}
					})
					.catch(err => {
						this.loadingDialog = false
						this.$toast.error('Vuelva a intentarlo mas tarde.')
						this.handleErrors(err.response.data.errors)
					})
					.then(() => {
						this.loadingDialog = false
					})
			},

			descargarLayoutRVOESFederales() {
				this.loadingDialog = true
				axios
					.get(api.path('titulos.layout'), { responseType: 'blob' })
					.then(res => {
						if (res.data.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
							let blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
							let link = document.createElement('a')
							link.href = window.URL.createObjectURL(blob)
							link.download = 'layout_rvoes_federales.xlsx'
							link.click()
						} else if (res.data.error) {
							this.$toast.error(res.data.error)
						} else {
							this.$toast.error('Vuelva a intentarlo mas tarde.')
						}
					})
					.catch(err => {
						this.loadingDialog = false
						this.$toast.error('Vuelva a intentarlo mas tarde.')
						this.handleErrors(err.response.data.errors)
					})
					.then(() => {
						this.loadingDialog = false
					})
			},

			descargarLayoutProgramasDeEstudio() {
				this.loadingDialog = true
				axios
					.get(api.path('programas.layout'), { responseType: 'blob' })
					.then(res => {
						if (res.data.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
							let blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
							let link = document.createElement('a')
							link.href = window.URL.createObjectURL(blob)
							link.download = 'layout_programas_de_estudio.xlsx'
							link.click()
						} else if (res.data.error) {
							this.$toast.error(res.data.error)
						} else {
							this.$toast.error('Vuelva a intentarlo mas tarde.')
						}
					})
					.catch(err => {
						this.loadingDialog = false
						this.$toast.error('Vuelva a intentarlo mas tarde.')
						this.handleErrors(err.response.data.errors)
					})
					.then(() => {
						this.loadingDialog = false
					})
			},

			descargarXLSXProgramasDeEstudio() {
				this.loadingDialog = true
				axios
					.get(api.path('programas.xlsx'), { responseType: 'blob' })
					.then(res => {
						if (res.data.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
							let blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
							let link = document.createElement('a')
							link.href = window.URL.createObjectURL(blob)
							link.download = 'programas_de_estudio.xlsx'
							link.click()
						} else if (res.data.error) {
							this.$toast.error(res.data.error)
						} else {
							this.$toast.error('Vuelva a intentarlo mas tarde.')
						}
					})
					.catch(err => {
						this.loadingDialog = false
						this.$toast.error('Vuelva a intentarlo mas tarde.')
						this.handleErrors(err.response.data.errors)
					})
					.then(() => {
						this.loadingDialog = false
					})
			},

			refactorizarAsignaturas() {
				this.loadingDialog = true
				axios
					.get(api.path('programas.refactorizar'), { responseType: 'blob' })
					.then(res => {
						this.$toast.success("Asignaturas recfactorizadas correctamente.")
					})
					.catch(err => {
						this.loadingDialog = false
						this.$toast.error('Vuelva a intentarlo mas tarde.')
						this.handleErrors(err.response.data.errors)
					})
					.then(() => {
						this.loadingDialog = false
					})
			},
		}
	}
</script>
